// extracted by mini-css-extract-plugin
module.exports = {"mainAdornment":"style_main-adornment__SK2dY"};